import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=2987c02e&scoped=true&"
import script from "@/views/Schedules/Schedule.ts?vue&type=script&lang=ts&"
export * from "@/views/Schedules/Schedule.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Schedules/schedule.scss?vue&type=style&index=0&id=2987c02e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2987c02e",
  null
  
)

export default component.exports